<template>
  <div class="md-content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <h1>Shortcut Groups v2</h1>

        <md-button href="/shortcuts/v2/group/create">
          Create group
        </md-button>

        <md-progress-bar
          v-if="isLoading"
          md-mode="query"
        />
        <v-client-table
          v-else
          ref="table"
          :data="groups"
          :columns="table.columns"
          class="shortcut-table"
        >
          <template #enabled="props">
            {{ props.row.enabled ? 'true' : 'false' }}
          </template>

          <template #title="props">
            <a
              :href="'/shortcuts/v2/group/edit/' + props.row.group_id"
              target="_blank"
              rel="noreferrer"
            >
              {{ props.row.title.en }}
            </a>
          </template>

          <template #shortcuts_access="props">
            {{ props.row.shortcuts_access }}
          </template>

          <template #shortcut_type="props">
            {{ props.row.shortcut_type }}
          </template>
        </v-client-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ShortcutGroupsTableV2",
  data() {
    return {
      groups: [],

      isLoading: true,
      table: {
        columns: [
          "enabled", "title", "shortcuts_access", "shortcut_type", "sequence_index"
        ],
      }
    };
  },
  mounted() {
    this.fetchGroups();
  },
  methods: {
    fetchGroups () {
      this.$http.get("/v1/admin/system/shortcut-group/list")
        .then(res => {
          this.groups = res.data.shortcut_groups;
          this.isLoading = false;
        }).catch(err => {
          console.error(err);
          this.$notify({
            group: "foo",
            title: "Couldn't load groups",
          });
        });
    }
  }
};
</script>
<style scoped>

</style>
